import { HTTP_INTERCEPTORS } from '@angular/common/http';
// TO DO: get here all the interceptors to be loaded in app.config, and there use just this provider
//import { CustomJsonInterceptor, CustomJsonParser, JsonParser } from './custom-json-interceptor';

//import { AuthInterceptor } from './auth-interceptor';
import { HeaderInterceptor } from './header-interceptor';
//import { CachingInterceptor } from './caching-interceptor';
//import { EnsureHttpsInterceptor } from './ensure-https-interceptor';
import { LoggingInterceptor } from './logging-interceptor';
import { NoopInterceptor } from './noop-interceptor';
//import { TrimNameInterceptor } from './trim-name-interceptor';
//import { UploadInterceptor } from './upload-interceptor';

/** Array of Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
//    { provide: HTTP_INTERCEPTORS, useClass: CustomJsonInterceptor, multi: true },
//    { provide: JsonParser, useClass: CustomJsonParser },
    { provide: HTTP_INTERCEPTORS, useClass: NoopInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
//    { provide: HTTP_INTERCEPTORS, useClass: EnsureHttpsInterceptor, multi: true },
//    { provide: HTTP_INTERCEPTORS, useClass: TrimNameInterceptor, multi: true },
//    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
//    { provide: HTTP_INTERCEPTORS, useClass: UploadInterceptor, multi: true },
//    { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
];
